import { XP } from '../types';

export const myXp: XP[] = [
  {
    position: 'Lead Developer',
    org: 'RT MIS',
    orgSite: 'https://rtmis.ru/',
    from: 'May 2021',
    to: 'Aug 2026',
    location: 'Novosibirsk, Russia',
    responsibilities: [
      {
        text: 'Led frontend development for a Business Analytics platform and Medical Services system',
        techs: [
          'React',
          'Single SPA',
          'Redux Toolkit',
          'Effector',
          'Styled Components',
          'LESS',
          'G2Plot',
          'Storybook',
        ],
      },
      {
        text: 'Managed and mentored a team of 2 frontend developers; established code standards',
        techs: [],
      },
      {
        text: 'Designed API contracts via OpenAPI specifications to streamline backend integration',
        techs: ['OpenAPI'],
      },
      {
        text: 'Engineered an internal UI library to accelerate feature delivery across projects',
        techs: ['React', 'Storybook', 'SCSS'],
      },
    ],
    achievements: [
      'Architected and delivered a complex Business Analytics platform completely from scratch',
      'Migrated a monolithic application into a scalable Micro-frontends architecture',
      'Deployed a custom UI library, significantly reducing product time-to-market',
    ],
  },
  {
    position: 'Team Leader',
    org: 'ELTEX',
    orgSite: 'https://eltex-co.com/',
    from: 'Apr 2017',
    to: 'Apr 2021',
    location: 'Novosibirsk, Russia',
    responsibilities: [
      {
        text: 'Acted as the Frontend Tech Lead for a Smart Home system, driving architecture and technical decisions',
        techs: ['Angular 7+', 'Vue', 'KnockoutJS'],
      },
      {
        text: 'Developed and maintained a corporate CRM system integrated with a Spring-based backend',
        techs: ['Spring', 'AngularJS', 'jQuery'],
      },
    ],
    achievements: [
      'Promoted from Junior Developer to Technical Lead due to strong ownership and technical expertise',
      'Successfully led the migration of a legacy codebase from KnockoutJS to modern Angular',
      'Modernized the core build infrastructure by migrating from RequireJS to Webpack, implementing ES6+, SCSS, icon font generation',
    ],
  },
  {
    position: 'Full Stack Developer',
    org: 'Edison Studio',
    orgSite: 'https://edisonstudio.ru/',
    from: 'Sep 2016',
    to: 'Mar 2017',
    location: 'Novosibirsk, Russia',
    responsibilities: [
      {
        text: 'Developed and optimized responsive public and administrative web interfaces',
        techs: ['Bootstrap 3', 'SCSS', 'jQuery'],
      },
      {
        text: 'Handled server-side engineering, module customization, and database architecture across various PHP frameworks and CMS platforms',
        techs: ['CMS Joomla', 'OpenCart', 'CodeIgniter', 'PHP', 'MySQL'],
      },
      'Ensured cross-browser compatibility and smooth user experience for diverse web applications',
    ],
    achievements: [
      'Solely engineered a custom e-mail client from scratch, implementing direct integrations with IMAP and SMTP protocols',
      'Developed a corporate CMS and a custom Task Tracker plugin for internal project management system',
    ],
  },
  {
    position: 'Laboratory Assistant',
    org: 'NSUEM',
    orgSite: 'https://nsuem.ru/',
    from: 'Jun 2013',
    to: 'Jun 2016',
    location: 'Novosibirsk, Russia',
    responsibilities: [
      {
        text: 'Developed native Android applications using Java, gaining early hands-on experience in mobile UI and application lifecycle',
        techs: ['Java', 'Android'],
      },
      {
        text: 'Built and optimized server-side web services and relational database structures',
        techs: ['MySQL', 'PHP'],
      },
    ],
  },
];
